import React from 'react';
import {
  StyledMainContentTitle,
  StyledMainHeading,
  StyledMainContentHeader,
  StyledMainContentHeaderWrapper,
} from '../Styled';

interface IMainContentHeader {
  headerText: string;
  headingText?: JSX.Element;
  showHeading: boolean;
  showShadow?: boolean;
  labelBgColor: string;
}

export const MainContentHeader = (props: IMainContentHeader): JSX.Element => {
  const { headerText, headingText, showHeading, showShadow = true, labelBgColor } = props;
  const excludedWords = ['and'];

  const headerModify = (): string => {
    const page = headerText.split('-');

    const result = page.map((element: string) => {
      return excludedWords.includes(element) ? element : element.charAt(0).toUpperCase() + element.slice(1);
    });

    return result.join(' ');
  };

  return (
    <StyledMainContentHeaderWrapper showShadow={showShadow}>
      <StyledMainContentHeader data-testid="main-content header">
        {showHeading && <StyledMainHeading data-testid="main-heading">{headingText}</StyledMainHeading>}
        <StyledMainContentTitle data-testid="main-content-title" bgColor={labelBgColor}>
          {headerModify()}
        </StyledMainContentTitle>
      </StyledMainContentHeader>
    </StyledMainContentHeaderWrapper>
  );
};
